import * as o from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/LockSimple.es.js";
const e = o.forwardRef((m, c) => /* @__PURE__ */ o.createElement(r, { ref: c, ...m, weights: t }));
e.displayName = "LockSimpleIcon";
const p = e;
export {
  p as LockSimple,
  e as LockSimpleIcon
};
